import React from 'react';
import { DateTime } from 'luxon';
import { Button, NakedButton } from '../../../components/Button';
import { Container, ColContainer, TPL_50_50, CardContainer } from '../../../components/Container';
import { GraphqlErrorMessage, ValidationErrorMessage } from '../../../components/ErrorMessage';
import { H1 } from '../../../components/Typography';
import { Helmet } from 'react-helmet';
import { useFormState } from 'react-use-form-state';
import { withInstallation } from '../../../components/InstallationContext';
import { useMutation } from '@apollo/client';
import { createSanctionedTimeMutation } from './queries';
import { DateTimeInput } from "../../../components/DateTimeInput";
import moment from "moment";

function SanctionedTimeCreate({ installation, history }) {
    const [{ errors, values, setField }] = useFormState({
        startDate: moment().set({ hours: 0, minutes: 0 }).format('YYYY-MM-DDTHH:mm:ss'),
        endDate: moment().set({ hours: 0, minutes: 0 }).format('YYYY-MM-DDTHH:mm:ss'),
    });

    const [createSanctionedTime, { error: submitError }] = useMutation(createSanctionedTimeMutation);

    const firstError = Object.values(errors)[0];
    const hasErrors = !!firstError;

    const canSubmit = (
      values.startDate &&
      values.endDate &&
      !hasErrors
    );

    async function onCreate() {
        if (!canSubmit) return;
        console.log(values);

        const { data } = await createSanctionedTime({
            variables: {
                installationId: installation.id,
                startDate: values.startDate,
                endDate: values.endDate,
            },
        });

        if (data?.createSanctionedTime) history.goBack();
        else errors.date = `Create error. Please, try again.`;
    }

    return (
      <CardContainer>
          <Container spaceAbove="medium" spaceBelow="medium">
              <Helmet><title>New Sanctioned Time</title></Helmet>
              <H1>New Sanctioned Time</H1>
              {submitError && <GraphqlErrorMessage spaceBelow="medium" error={submitError} />}
              {hasErrors && <ValidationErrorMessage spaceBelow="medium" error={firstError} />}

              <ColContainer columnTemplate={TPL_50_50} spaceAbove="medium">
                  <DateTimeInput
                    floatPicker
                    value={moment(values.startDate)}
                    onChange={(date) => {
                        const formatted = moment.isMoment(date)
                          ? date.format('YYYY-MM-DDTHH:mm:ss')
                          : DateTime.fromJSDate(date).toFormat('yyyy-MM-dd HH:mm:ss');

                        setField('startDate', formatted);
                    }}
                  />

                  <DateTimeInput
                    floatPicker
                    value={moment(values.endDate)}
                    onChange={(date) => {
                        const formatted = moment.isMoment(date)
                          ? date.format('YYYY-MM-DDTHH:mm:ss')
                          : DateTime.fromJSDate(date).toFormat('yyyy-MM-dd HH:mm:ss');

                        setField('endDate', formatted);
                    }}
                  />
              </ColContainer>
              <div>
                  <Button type="submit" style={{ cursor: 'pointer' }} spaceAbove="small" onClick={onCreate}>Create</Button>
                  <NakedButton style={{ cursor: 'pointer' }} flavour="gray" spaceAbove="small" onClick={() => history.goBack()}>Cancel</NakedButton>
              </div>
          </Container>
      </CardContainer>
    );
}

export default withInstallation(SanctionedTimeCreate);
